// extracted by mini-css-extract-plugin
module.exports = {"root":"Choice_root__HkUgA","dragIcon":"Choice_dragIcon__1m4eX","left":"Choice_left__1qwyK","input":"Choice_input__3r4SO"};